import React, { useCallback, useEffect, useState } from 'react';
import BASE_URL from '../config';

export const isReservedAccount = (username) => /^(test|demo)\d{2}@mavistech\.uk$/i.test(username || '');
export const reservedKind = (username) => {
  const m = /^(test|demo)\d{2}@mavistech\.uk$/i.exec(username || '');
  return m ? m[1].toLowerCase() : null;
};

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
});

export const ReservedBadge = ({ username }) => {
  const kind = reservedKind(username);
  if (!kind) return null;
  return (
    <span style={{ marginLeft: 6, padding: '1px 7px', borderRadius: 10, fontSize: 11, fontWeight: 700,
      background: kind === 'demo' ? '#7c3aed' : '#d97706', color: '#fff' }}>
      {kind === 'demo' ? 'DEMO' : 'TEST'}
    </span>
  );
};

/** Shows what is linked to a testing/demo account and lets an admin unlink it. */
const TestAccountPanel = ({ userId, username }) => {
  const [linked, setLinked] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const load = useCallback(async () => {
    try {
      const r = await fetch(`${BASE_URL}/api/admin/users/${userId}/test-account-devices/`, { headers: authHeaders() });
      const j = await r.json();
      setLinked(j.linked || []);
    } catch (e) { setLinked([]); }
  }, [userId]);

  useEffect(() => { if (isReservedAccount(username)) load(); }, [load, username]);

  if (!isReservedAccount(username)) return null;
  const kind = reservedKind(username);

  const unlink = async () => {
    const what = (linked || []).map((l) => `glasses ${l.glasses_serial}${l.case_serial ? ` + case ${l.case_serial}` : ''}`).join(', ');
    if (!window.confirm(`Unlink ${what} from ${username}? The devices stay registered and can be linked again.`)) return;
    setBusy(true); setMsg('');
    try {
      const r = await fetch(`${BASE_URL}/api/admin/users/${userId}/test-account-devices/`, { method: 'POST', headers: authHeaders() });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'Could not unlink.');
      setMsg(`Unlinked ${j.unlinked.length} device(s).`);
      await load();
    } catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };

  return (
    <div role="region" aria-label="Testing account devices"
      style={{ margin: '0 0 12px', padding: '8px 14px', borderRadius: 8, border: '1px solid #7c3aed', background: 'rgba(124,58,237,.18)', color: '#e5e7eb', fontSize: 14 }}>
      <strong>{kind === 'demo' ? 'Demo account' : 'Testing account'}</strong>
      {linked === null ? ' — loading…' : linked.length === 0 ? ' — free (nothing linked).' : (
        <span>
          {' — in use: '}
          {linked.map((l) => `glasses ${l.glasses_serial}${l.case_serial ? ` + case ${l.case_serial}` : ' (no case paired)'}`).join('; ')}
        </span>
      )}
      {linked && linked.length > 0 && (
        <button type="button" onClick={unlink} disabled={busy}
          style={{ marginLeft: 12, background: '#dc2626', color: '#fff', border: 0, borderRadius: 6, padding: '6px 14px', cursor: 'pointer' }}>
          {busy ? 'Unlinking…' : 'Unlink glasses and case'}
        </button>
      )}
      {msg && <div role="status" style={{ marginTop: 6 }}>{msg}</div>}
    </div>
  );
};

export default TestAccountPanel;
